import { makeSafeRequest, handleStream } from './api/api-helpers'
import { decodeJWT } from './proxy/proxy-helpers'
import {
  getTermsByLocale,
  getItemsFromReservation,
  getItemsWithoutFee,
  getNumOfPriceCategorySubTypesFromItems,
  getVesselTitleFromReservation,
  getDepartureAndArrivalDataFromReservation,
  getPortsFromSailPackage,
  getDepartureAndArrivalFromSailPackage,
  getVehiclesFromItemsAndReservation,
  getSailRefIdsFromReservation,
  getRefundStatusesFromReservation,
  getAllowanceFromReservation,
  getCancellationInfoFromReservation,
  getPhoneProp,
  getItemsWithFee,
} from './reservation/reservation-helpers'
import { formatToFixedNumber, getDateFromISODate, sanitizeHtml } from '@/root/shared-helpers/utils/utils'
import {
  dateToFormat,
  dateToFormatFromISODate,
  dateToFormattedString,
  formatedDateToAnotherFormat,
  isDateInPast,
} from '@/root/shared-helpers/date/dateHelpers'
import { checkIsDayDisabled } from '@/root/shared-helpers/day-picker/dayPicker'
import {
  isLegRefundedByCustomer,
  isLegCancelledByAdmin,
  isTripRefundedByCustomer,
  isTripCancelledByAdmin,
  hasLiveLeg,
} from '@/root/shared-helpers/reservation/sail-cancellation'
import {
  validatePhoneNumber,
  validateEmail,
  validatePassword,
  isValidEmailOrPhoneNumber,
} from '@/root/shared-helpers/validators/validators'
import { getEnabledPaymentMethodsInDisplayOrder } from '@/root/shared-helpers/payment/payment-helpers'

export {
  makeSafeRequest,
  decodeJWT,
  getTermsByLocale,
  getItemsFromReservation,
  getNumOfPriceCategorySubTypesFromItems,
  getVesselTitleFromReservation,
  getItemsWithoutFee,
  getDepartureAndArrivalDataFromReservation,
  getPortsFromSailPackage,
  getDepartureAndArrivalFromSailPackage,
  getVehiclesFromItemsAndReservation,
  getSailRefIdsFromReservation,
  handleStream,
  getRefundStatusesFromReservation,
  getAllowanceFromReservation,
  getCancellationInfoFromReservation,
  getPhoneProp,
  isLegRefundedByCustomer,
  isLegCancelledByAdmin,
  isTripRefundedByCustomer,
  isTripCancelledByAdmin,
  hasLiveLeg,
  formatToFixedNumber,
  getDateFromISODate,
  sanitizeHtml,
  dateToFormat,
  dateToFormattedString,
  checkIsDayDisabled,
  getItemsWithFee,
  dateToFormatFromISODate,
  validatePhoneNumber,
  validateEmail,
  validatePassword,
  isValidEmailOrPhoneNumber,
  isDateInPast,
  formatedDateToAnotherFormat,
  getEnabledPaymentMethodsInDisplayOrder,
}
